
import { useEffect, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Loader from '../Layout/Loader';
import { BindGrid, exportToExcel, setFocus, setTitle } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox } from '../Common/Input';
import { useNavigate } from "react-router-dom";

const PriceListMaster = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [MenuText, setMenuText] = useState("Price List Master");

    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{

        }]
    })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [SaveData, setSaveData] = useState({
        PriceListID: "0",
        PriceListCode: "",
        PriceListName: "",
        Active: true
    });

    const handleClear = async () => {
        setSaveData({
            PriceListID: "0",
            PriceListCode: "",
            PriceListName: "",
            Active: true
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setIsUpdate(!isUpdate)
    }
    useEffect(() => {
        setTitle('PriceListMaster', setOpen);
        setFocus('txtPriceListCode')
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);
    useEffect(() => {
        getPriceListData();
    }, [filterData.PageIndex, isUpdate]);

    const handleSubmit =  () => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);

        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Master/InsertUpdatePriceListMaster`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                handleClear();
                getPriceListData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
                setIsLoading(false);
            if (res.focus !== "") {
                setFocus(res.focus)
            }

        })
    }
    const getPriceListData =  (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExPriceListData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'PriceListMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]

                    })
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            setIsLoading(false)
        })
    }

    const handleEditData =  (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, PriceListID: ID
        }
        post(`${API_SERVER}/api/Master/EditPriceListData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setSaveData({
                    PriceListID: ID,
                    PriceListCode: editRecordJson[0]['PriceList Code'],
                    PriceListName: editRecordJson[0]['PriceList Name'],
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false)
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')

            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)

            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }
    const handleDeleteData = (ID) => {
        const loginCodeString = String(LoginUserCode);

        setIsLoading(true)
        let data = {
            Token, LoginUserCode: loginCodeString, PriceListID: ID
        }
        post(`${API_SERVER}/api/Master/DeletePriceListData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                AlertBox(res.status, res.message, res.focus)
                getPriceListData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false);
            }
        })
    }

    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getPriceListData();
    }
    const handleDownloadExcel = async () => {
        getPriceListData('E');
    }

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">                                   
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Price List Code<span className="Required">*</span></label>
                                            <input
                                                disabled={SaveData.PriceListID !== "0" ? true : false}
                                                id='txtPriceListCode'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtPriceListName')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Price List Code'
                                                value={SaveData.PriceListCode}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, PriceListCode: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Price List Name<span className="Required">*</span></label>
                                            <input
                                                id='txtPriceListName'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('chkActive')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Price List Name'
                                                value={SaveData.PriceListName}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, PriceListName: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="chkActive"
                                                name='Active'
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSave')
                                                    };
                                                }}
                                                checked={SaveData.Active}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Active: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-2">
                                        <div className="lms-new-button text-center">
                                            {SaveData.PriceListID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle}  handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='PriceListMaster' />
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
      
        </main>
    )
}

export default PriceListMaster